import { type Component, Show } from "solid-js";
import { useI18n } from "@/api/i18n";
import type { Bonus } from "../types";

export const BonusItem: Component<{
  bonusKey: Bonus;
  value: string;
  dense?: boolean;
}> = (props) => {
  const { t } = useI18n();

  // Return null if value is not truthy
  if (!props.value?.trim()) {
    return null;
  }

  const isPercentageBonus =
    props.bonusKey === "roi" || props.bonusKey === "provision";
  const isEquityBonus = props.bonusKey === "work_for_equity";

  return (
    <div
      class="rounded-lg"
      classList={{
        "bg-gray-50": isPercentageBonus,
        "bg-green-50": isEquityBonus,
        "p-2": props.dense,
        "p-3": !props.dense,
      }}
    >
      <div class="flex items-center gap-2" classList={{ "mb-2": !props.dense }}>
        <p class="text-sm font-medium">
          {t(`joblist.jobOffer.bonus.${props.bonusKey}`)}
        </p>
        <span class="text-sm font-medium">{props.value}%</span>
      </div>
      <Show when={!props.dense}>
        <p class="text-xs text-gray-600">
          {t(`joblist.jobOffer.bonusDescription.${props.bonusKey}`)}
        </p>
      </Show>
    </div>
  );
};
